<template>
  <Layout v-loading="isLoading">
    <template #top>
      <h1 class="page-title">资产绑定</h1>
    </template>

    <el-form :model="form" ref="form" label-width="100px" class="demo-dynamic">
      <el-form-item
        prop="businessList"
        label="商务平台ID"
        :rules="[
          { required: true, message: '请输入商务平台ID', trigger: 'blur' },
        ]"
      >
        <el-input
          v-model="form.businessList"
          placeholder="多个商务平台使用分号间隔 例如:12345;67890"
        ></el-input>
      </el-form-item>
      <template v-for="(item, index) in form.property">
        <el-divider content-position="center">{{
          `资产信息 ${index + 1}`
        }}</el-divider>
        <el-form-item
          label="游戏ID"
          :prop="'property.' + index + '.appId'"
          :rules="{
            required: true,
            message: '游戏ID不能为空',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="item.appId"
            placeholder="输入应用编号 例如:760271929217459"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="游戏名称"
          :prop="'property.' + index + '.appName'"
          :rules="{
            required: true,
            message: '游戏名称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="item.appName"
            placeholder="输入游戏名称 例如:填字大师"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="资产ID"
          :prop="'property.' + index + '.assetId'"
          :rules="{
            required: true,
            message: '资产ID不能为空',
            trigger: 'blur',
          }"
        >
          <el-input
            v-model="item.assetId"
            placeholder="输入资产ID 例如:123456789"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商务平台"
          :prop="'property.' + index + '.businessId'"
          :rules="{
            required: true,
            message: '所属平台不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="item.businessId" placeholder="请选对应平台">
            <el-option
              v-for="(item, index) in selectValue"
              :label="item"
              :value="item"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="delete" v-if="index > 0">
          <el-button @click.prevent="removeDomain(item)" type="danger" plain
            >删除</el-button
          >
        </div>
      </template>
      <el-form-item>
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
        <el-button @click="addDomain">新增资产</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </el-form-item>
    </el-form>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import getBusinessByCode from "@/api/getBusinessByCode.js";

export default {
  components: {
    Layout,
  },
  created() {
    this.checkUrl();
  },
  computed: {
    selectValue() {
      let ids = this.form.businessList;
      return ids ? ids.split(";") : [];
    },
  },
  data() {
    return {
      code: "",
      isLoading: false,
      form: {
        property: [
          {
            appId: "",
            appName: "",
            assetId: "",
            businessId: "",
          },
        ],
        businessList: "",
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.isLoading = true;
          let res = await getBusinessByCode({
            code: this.code,
            businessParamList: this.form.property,
          });
          this.isLoading = false;
          if (res == "ok") {
            const h = this.$createElement;
            this.$notify({
              title: "资产已绑定",
              message: h("div", null, [
                h("p", null, `绑定商务平台数量: ${this.selectValue.length}`),
                h("p", null, `绑定资产数量: ${this.form.property.length}`),
              ]),
              type: "success",
            });
            this.$router.push("/home/authorize/page");
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      if (this.form.property.length < 2) {
        return;
      }
      var index = this.form.property.indexOf(item);
      if (index !== -1) {
        this.form.property.splice(index, 1);
      }
    },
    addDomain() {
      this.form.property.push({
        appId: "",
        appName: "",
        assetId: "",
        businessId: "",
      });
    },
    async checkUrl() {
      let code = new URLSearchParams(window.location.search).get("code");
      if (code) {
        this.code = code;
      } else {
        // this.$router.push("/home/authorize/page");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-divider {
  background-color: black;
}

.delete {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-form-item__content {
    margin-left: 0px;
  }
}
</style>
